// extracted by mini-css-extract-plugin
export default {"blockScreen":"Confirmation_blockScreen__yZ6d5"};